<template>
  <div class="message-box-wrap">
    <div
      @click="hideMessage"
      class="message-box"
    >
      {{ message }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'global-message',
  computed: {
    message() {
      return this.$store.state.message.text
    },
  },
  mounted() {
    setTimeout(() => {
      this.hideMessage()
    }, 6000)
  },
  methods: {
    ...mapActions({
      hideMessage: 'hideMessage',
    }),
  },
}
</script>

<style scoped>
.message-box-wrap {
  position: fixed;
  display: flex;
  justify-content: center;
  bottom: 50px;
  left: 0;
  right: 0;
}
.message-box {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  color: hsla(0, 0%, 100%, 0.87);
  background-color: #333;
  max-width: 672px;
  padding: 14px 16px;
  font-size: 14px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
}
.message-box:hover {
  cursor: pointer;
}
</style>
